import { render, staticRenderFns } from "./VersionHistory.vue?vue&type=template&id=d7bba2f0&"
import script from "./VersionHistory.vue?vue&type=script&lang=js&"
export * from "./VersionHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports